import { NgIf } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { StandardResponseDTO } from 'src/app/interfaces/standardresponse';
import { createLogin, UserDTO } from 'src/app/interfaces/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ErrorhandlingService } from 'src/app/services/errorhandling.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';

@Component({
  selector: 'app-register',
  imports: [FormsModule, MatIconModule, MatLabel, MatFormFieldModule, ReactiveFormsModule, NgIf, MatInputModule, MatButtonModule,
    MatCheckboxModule
  ],
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  form: any = {
    email: null,
    password: null
  };
  isSuccessful = false;
  isSignUpFailed = false;
  errorMessage = '';
  hide = true;
  deviceId: string;
  registerForm: FormGroup;
  user: UserDTO = {
    id: -1,
    email: '',
    role: '',
    accessToken: '',
    refreshToken: '',
    calendarId: -1
  };
  emailNotUnique = false;
  standardResponse: StandardResponseDTO;

  constructor(private authenticationService: AuthenticationService, private tokenStorage: TokenStorageService,
    private router: Router, public dialogRef: MatDialogRef<RegisterComponent>, @Inject(MAT_DIALOG_DATA) data
  ) { }

  ngOnInit(): void {
    this.deviceId = this.tokenStorage.getDeviceId();
    this.registerForm = new FormGroup({
      email: new FormControl(this.form.email, [
        Validators.required,
        //Validators.pattern("^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$"),
        Validators.email
      ]),
      password: new FormControl(this.form.password, [
        Validators.required,
        Validators.minLength(6)
      ]),
      agreeToTerms: new FormControl(this.form.agreeToTerms, [
        Validators.requiredTrue
      ])
    });
  }


  async onSubmit() {
    try {

      const data = await firstValueFrom(this.authenticationService.register(createLogin(this.form.email, this.form.password, this.deviceId)));
      if (data) {
        this.isSuccessful = true;
        this.isSignUpFailed = false;
        if (data.accessToken) {
          this.user = data;
          this.tokenStorage.saveToken(data.accessToken);
          this.tokenStorage.saveRefreshToken(data.refreshToken);
          this.tokenStorage.saveUser(this.user);

          setTimeout(() => {
            this.dialogRef.close();
            this.router.navigate(['']);
          }, 2500);
        }
      } else {
        this.errorMessage = 'Failed to register, pls try with a different username/email.';
        this.isSignUpFailed = true;
      }
    } catch (error) {
      this.errorMessage = 'Failed to register, pls try with a different username/email.';
      this.isSignUpFailed = true;
    }
  }

  async validateEmail() {
    this.user.email = this.form.email;
    this.emailNotUnique = false;
    this.standardResponse = await firstValueFrom(this.authenticationService.validateEmail(createLogin(this.form.email, this.form.password, this.deviceId)));

    if (this.standardResponse != null && this.standardResponse.responseParameter != null) {
      if (this.standardResponse.responseParameter == 'notunique') {
        this.emailNotUnique = true;
      }
    }
  }

  resetForm() {
    this.form.email = '';
    this.form.password = '';
    this.emailNotUnique = false;
    this.registerForm.get('agreeToTerms')?.setValue(false);
  }

  get email() { return this.registerForm.get('email'); }
  get password() { return this.registerForm.get('password'); }
  get agreeToTerms() { return this.registerForm.get('agreeToTerms'); }

}